<template>
  <div>
    <FormSection title="Sponsorships:">
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
          <div class="amount-row">
            <input
              :id="`amount${amounts[0][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[0][0]"
              :checked="selectedAmount == amounts[0][0]"
            />
            <FormLabel :for="`amount${amounts[0][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[0][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[0][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[1][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[1][0]"
              :checked="selectedAmount == amounts[1][0]"
            />
            <FormLabel :for="`amount${amounts[1][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[1][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[1][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[2][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[2][0]"
              :checked="selectedAmount == amounts[2][0]"
            />
            <FormLabel :for="`amount${amounts[2][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[2][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[2][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[3][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[3][0]"
              :checked="selectedAmount == amounts[3][0]"
            />
            <FormLabel :for="`amount${amounts[3][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[3][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[3][1] }}</span>
            </FormLabel>
          </div>
        </div>
      </div>
    </FormSection>
    <FormSection title="Ads in the Playbill:">
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
          <div class="amount-row">
            <input
              :id="`amount${amounts[4][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[4][0]"
              :checked="selectedAmount == amounts[4][0]"
            />
            <FormLabel :for="`amount${amounts[4][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[4][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[4][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[5][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[5][0]"
              :checked="selectedAmount == amounts[5][0]"
            />
            <FormLabel :for="`amount${amounts[5][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[5][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[5][1] }}</span>
            </FormLabel>
          </div>
        </div>
      </div>
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
          <div class="amount-row">
            <input
              :id="`amount${amounts[6][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[6][0]"
              :checked="selectedAmount == amounts[6][0]"
            />
            <FormLabel :for="`amount${amounts[6][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[6][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[6][1] }}</span>
            </FormLabel>
          </div>
        </div>
      </div>
    </FormSection>
    <FormSection title="Other Amount:">
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
          <div class="amount_other__wrapper amount-row">
            <input
              id="amount_other_check2"
              type="radio"
              class="amount"
              :checked="customSelected"
              @click="customSelected = true"
            />
            <input
              type="number"
              min="1"
              name="amount_other"
              placeholder="Other amount"
              v-model="customAmount"
            />
          </div>
        </div>
      </div>
    </FormSection>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  data() {
    return {
      view: "welcome",
    };
  },  props: {
    campaign: String,
    nocustom: Boolean,
  },
  setup(props) {
    const { setValue, form, submit, settings } = usePaymentForm();

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    const selectedAmount = ref();
    const selectedAllocationAmount = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        if (selectedAllocationAmount.value) {
          setValue(
            "amount",
            "" + (parseInt(selectedAmount) + selectedAllocationAmount.value)
          );
        } else {
          setValue("amount", "" + selectedAmount);
        }
      }
    });

    watch(selectedAllocationAmount, (selectedAllocationAmount) => {
      if (selectedAllocationAmount) {
        customSelected.value = false;

        customAmount.value = null;

        if (selectedAmount.value) {
          setValue(
            "amount",
            "" + (parseInt(selectedAllocationAmount) + selectedAmount.value)
          );
        } else {
          setValue("amount", "" + selectedAllocationAmount);
        }
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
      if (!selectedAllocationAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      selectedAllocationAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    return {
      form,
      amounts,
      selectedAmount,
      selectedAllocationAmount,
      customAmount,
      clearOutSelectedValue,
      customSelected,
    };
  },
});
</script>
<style scoped lang="scss">
.selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    font-weight: 400;
    font-size: 20px;
    color: black;
  }
  select {
    max-width: 300px;
    margin-left: 20px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: bold;
  display: inline-block;
  padding: 10px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 10px;
  align-items: center;
  justify-content: center;
  height: 100%;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.minyan-section {
  padding: 0.5rem 0 0;
}
</style>
